import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "b-form-checkbox-input",
})
export default class InputOtherComponent extends Vue {
  // ----------------------------------------------------------------
  // Properties

  public text!: string;
  public previewPayLoadData: any;

  @Prop()
  public value!: string;
  @Prop()
  public payloadData: any;
  @Prop()
  public payloadDataAll: any;
  @Prop()
  public previewPayload: any;
  @Prop()
  public isTextAreaDisable: any;
  @Prop()
  public keyName: any;

  public get isShowInput() {
    if (this.payloadData) {
      const {
        ethnicHeritage = [],
        highSchool = [],
        licences = [],
      } = this.payloadData;
      const key: string = (this.keyName || "").toLowerCase();
      // Route by field name to show only for the matching checkbox group
      if (key.includes("ethnic")) {
        return (
          (ethnicHeritage as string[]).includes(
            "Not Listed (Please Specify)"
          ) || (ethnicHeritage as string[]).includes("Other")
        );
      }
      if (key.includes("highschool") || key.includes("high_school")) {
        return (highSchool as string[]).includes("Other");
      }
      // Licences text input (Strapi field name may vary, falls here as fallback)
      return (licences as string[]).includes("Other");
    } else if (
      this.previewPayload.certificationPartOneBasicDetails &&
      this.previewPayload.certificationPartOneEducationExperience
    ) {
      const { ethnicHeritage = [] } =
        this.previewPayload.certificationPartOneBasicDetails;
      return ethnicHeritage.indexOf("Not Listed (Please Specify)") !== -1;
    }
  }

  public created() {
    this.text = this.value;
  }
  public updated() {
    if (!this.isShowInput) {
      this.text = "";
    }
    this.$emit("input", this.text);
  }
  onChangeInput() {
    this.$emit("input", this.text);
  }
}
